import type { Place } from './types';

/**
 * The trip in the address bar: `/choose?from=32.83370,74.58290~Main%20Bazaar&to=…`. Coordinates to 5 decimals
 * (~1 m), then the place's name. Lets a refresh, Back/Forward or a pasted link open the same trip.
 */
export type TripSearch = { from?: string; to?: string };

const ok = (n: number, lo: number, hi: number) => Number.isFinite(n) && n >= lo && n <= hi;

export function encodePlace(p: Place): string {
  return `${p.lat.toFixed(5)},${p.lng.toFixed(5)}${p.address ? `~${p.address.slice(0, 120)}` : ''}`;
}

export function decodePlace(v: unknown): Place | null {
  if (typeof v !== 'string') return null;
  const [coords, ...name] = v.split('~');
  const [lat, lng] = coords.split(',').map(Number);
  if (!ok(lat, -90, 90) || !ok(lng, -180, 180)) return null;
  const address = name.join('~').trim();
  return { lat, lng, address: address || null };
}

/** Route `validateSearch`: keeps only well-formed places. */
export function tripSearch(s: Record<string, unknown>): TripSearch {
  const out: TripSearch = {};
  if (decodePlace(s.from)) out.from = s.from as string;
  if (decodePlace(s.to)) out.to = s.to as string;
  return out;
}

/** The search params for a trip (what Choose ride and Confirm pickup put in the address). */
export const tripParams = (pickup: Place, drop: Place | null): TripSearch => ({ from: encodePlace(pickup), ...(drop ? { to: encodePlace(drop) } : {}) });
